// src/routes/RedirectToLoginWithReturnUrl.jsx
/**
 * Saves the current location as the intended return URL and redirects to /login.
 * Used by PrivateRoute and Routes.jsx when an unauthenticated user hits a protected path.
 */
import { useEffect } from "react";
import { Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { saveIntendedReturnUrl } from "../auth";
import { logReturnUrlFlow } from "../auth/returnUrlDebug";
import { preloadRouteNamespaces } from "./routePreloaders";

export default function RedirectToLoginWithReturnUrl() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const returnTo = `${location.pathname}${location.search}${location.hash}`;
    saveIntendedReturnUrl(returnTo);
    logReturnUrlFlow("RedirectToLoginWithReturnUrl", { returnTo });
    void preloadRouteNamespaces(returnTo);
    navigate("/login", {
      replace: true,
      state: { returnTo },
    });
  }, [location.hash, location.pathname, location.search, navigate]);

  return (
    <div
      style={{
        flex: 1,
        alignSelf: "stretch",
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Spin size="large" />
    </div>
  );
}
